<div class="header-group" fxLayout="row" fxLayoutAlign="space-between center">
  <div fxLayout="row">
    <div>
      <span class="title-header">Trip and Mileage Dashboard</span>
      <!-- <sup
        ><i
          *ngIf="!isNewWindow"
          class="fa fa-window-restore open-window"
          (click)="openWindow()"></i
      ></sup> -->
    </div>
  </div>
</div>
<div class="content">
  <!-- <div class="select-row">
    <mat-form-field
      appearance="outline"
      class="form-field"
      subscriptSizing="dynamic"
      hideRequiredMarker>
      <mat-label>Date Period</mat-label>
      <mat-select
        name="selectedPeriod"
        [(ngModel)]="selectedPeriod"
        #periodSelect
        (valueChange)="onPeriodSelect($event)">
        <mat-option *ngFor="let period of periodRange" [value]="period.value">
          {{ period.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <app-date-selector
      [hidden]="selectedPeriod !== 'date'"
      [maxDays]="31"
      (dateRangeChange)="onSearchDate($event)"></app-date-selector>
  </div> -->
  <div class="content-row">
    <div class="content-cell row">
      <app-donut-card
        [data]="tripAttendanceOptions"
        [values]="
          reportDashboardApiService.selectedTripAttendance?.values
        "></app-donut-card>
      <app-donut-card
        [data]="mileageOptions"
        [values]="
          reportDashboardApiService.selectedTripMileage?.values
        "></app-donut-card>
    </div>
    <div class="content-cell text-cards">
      <div class="text-card-content">
        <app-text-card
          [values]="reportDashboardApiService.routeIds?.length ?? 0"
          label="Routes"></app-text-card>
        <app-text-card
          [values]="reportDashboardApiService.totalPlan ?? 0"
          label="Planned Trips"></app-text-card>
        <app-text-card
          [values]="reportDashboardApiService.totalActual ?? 0"
          label="Actual Trips"></app-text-card>
      </div>
      <div class="text-card-content">
        <app-text-card
          [values]="reportDashboardApiService.totalPlanMileage ?? 0"
          valueLabel="km"
          label="Plan Mileage"></app-text-card>
        <app-text-card
          [values]="reportDashboardApiService.totalActualMileage ?? 0"
          valueLabel="km"
          label="Actual Mileage"></app-text-card>
        <!-- <app-text-card></app-text-card> -->
      </div>
    </div>
  </div>
  <div class="content-row">
    <div class="content-cell">
      <app-stacked-column-card
        [values]="reportDashboardApiService.selectedTripPerformance?.values"
        [data]="tripPerformanceOptions"></app-stacked-column-card>
    </div>
    <div class="content-cell">
      <app-stacked-area-card
        [values]="reportDashboardApiService.selectedMileageSchedule?.values"
        [data]="mileageScheduleOptions"></app-stacked-area-card>
    </div>
  </div>
</div>
